<template>
    <div class="verified-input multi">
        <VerifiedLable
            :id="id"
            :title="title"
            :tagnewid="tagnewid"
            :required="required"
            :disableMLtitle="disableMLtitle"
            :tooltipLabel="tooltipLabel"
            :tooltipPosition="tooltipPosition"
            :tooltipType="tooltipType"
            :tooltipSize="tooltipSize"
            :tooltipMultilined="tooltipMultilined"
        />
        <v-select
            ref="selectInput"
            :label="label"
            :options="options"
            :value="value"
            :loading="loading"
            :close-on-select="closeOnSelect"
            :placeholder="
                disableMLplaceholder
                    ? placeholder
                    : getT(placeholder, '')
            "
            :clearable="noclear"
            :class="{ invalid: focusedOut && invalid, smaller: smaller }"
            :disabled="disabled"
            @search="emitSearch"
            @input="emitValue"
            multiple
        >
            <template slot="no-options">{{
                $t('sem-resultados-filtro')
            }}</template>
            <template slot="option" slot-scope="option">
                <slot name="option" :bind="option">
                    <span
                        class="option-label"
                        v-if="mlLabels"
                        :title="option ? $t(getLabel(option)) : ''"
                    >
                        {{ option ? $t(getLabel(option)) : '' }}
                    </span>
                    <span class="option-label" v-else :title="getLabel(option)">
                        {{ getLabel(option) }}
                    </span>
                </slot>
            </template>
            <template slot="selected-option" slot-scope="option">
                <slot name="selected-option" :bind="option">
                    <div class="selected">
                        <span
                            class="option-label"
                            v-if="mlLabels"
                            :title="option ? $t(getLabel(option)) : ''"
                        >
                            {{ option ? $t(getLabel(option)) : '' }}
                        </span>
                        <span class="option-label" v-else :title="getLabel(option)">
                            {{ getLabel(option) }}
                        </span>
                    </div>
                </slot>
            </template>
        </v-select>
        <span
            class="validation"
            v-text="getT(msg, '')"
            v-if="focusedOut && invalid"
        />
    </div>
</template>

<script>
// component vms-select

import VerifiedLable from '@/components/shared/VerifiedLable.vue';

export default {
    components: {
        VerifiedLable,
    },
    props: {
        value: {
            default: null,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        options: {
            type: Array,
            default: () => [],
        },
        keydown: {
            type: Function,
            default: (val) => {},
        },
        id: {
            default: new Date().getTime(),
        },
        placeholder: {
            default: '',
            type: String,
        },
        title: {
            default: '',
            type: String,
        },
        label: {
            default: 'label',
            type: String,
        },
        mlLabels: {
            type: Boolean,
            default: false,
        },
        // campo usado para traduzir itens especificos da lista de itens.
        // essa variável deve receber o nome do campo usado para definir
        // se deve ou não ser traduzido.
        //
        // Ex.: [{value: 1, label: todos, traduzir: true},
        //      {value: 2, label: Sovis sistemas, traduzir: false}]
        // :mlLabelsField: "'traduzir'"
        //
        // **** somente ser usado sem mlLabels
        mlLabelsField: {
            type: String,
            default: '',
        },
        msg: {
            default: 'msg-campo-obrigatorio',
            type: String,
        },
        invalid: {
            default: false,
            type: Boolean,
        },
        onBlur: {
            default: true,
            type: Boolean,
        },
        nextEl: {
            default: null,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        noclear: {
            type: Boolean,
            default: false,
        },
        smaller: {
            type: Boolean,
            default: false,
        },
        disableMLtitle: {
            type: Boolean,
            default: false,
        },
        // Id do tagnew referente ao .env na raiz do sistema
        tagnewid: undefined,
        // O título fica com a cor primária da empresa e com um asterisco após o título
        required: {
            type: Boolean,
            default: false,
        },
        /* Caso tenha uma informação adicional sobre o campo */
        tooltipLabel: {
            type: String,
            default: null,
        },
        tooltipPosition: {
            type: String,
            default: 'is-right',
        },
        tooltipType: {
            type: String,
            default: 'is-dark',
        },
        tooltipMultilined: {
            type: Boolean,
            default: true,
        },
        tooltipSize: {
            type: String,
            default: 'is-large',
        },
        disableMLplaceholder: {
            type: Boolean,
            default: false,
        },
        closeOnSelect: {
            type: Boolean,
            default: true,
        },
    },
    mounted() {
        let inputSearch = this.$refs.selectInput.$refs.search;
        inputSearch.addEventListener('keydown', this.keydown);
        inputSearch.addEventListener('blur', this.blurEvt);
        inputSearch.addEventListener('focus', this.focusEvt);

        // let selectedOptions = this.$refs.selectInput.$refs.selectedOptions;
        // selectedOptions.addEventListener('click', this.clickListener);
    },
    data() {
        return {
            focusedOut: false,
        };
    },

    methods: {
        emitValue(v) {
            this.$emit('input', v);
        },
        emitSearch(q) {
            this.$emit('search', q);
        },
        getOptionLabel(value) {
            this.$refs.selectInput.getOptionLabel(value);
        },
        typeAheadSelect() {
            this.$refs.selectInput.typeAheadSelect();
        },
        focusEvt() {
            this.focusedOut = false;
        },
        blurEvt() {
            this.focusedOut = true;
            // para quando quiser apenas saber se foi executado o blur
            this.$emit('onBlurFunction');
        },
        getLabel(o) {
            if (typeof o === 'string' || o == null) {
                return o;
            } else if (typeof o === 'object') {
                if (o[this.label] != undefined) {
                    if (o[this.mlLabelsField] && !this.mlLabels) {
                        return this.$t(o[this.label]);
                    }
                    return o[this.label];
                } else {
                    console.warn(
                        `[VERIFIED SELECT] A propriedade [${this.label}] não existe no objeto de opção!`
                    );
                    return '';
                }
            }
        },
    },
};
</script>

<style lang="scss">
.verified-input.multi {
    span.validation {
        font-size: 8px;
        color: $red;
        display: block;
        font-weight: 600;
    }

    .invalid > div.vs__dropdown-toggle {
        border: 1px solid $red-alert !important;
    }

    input {
        margin-bottom: 0 !important;
    }

    .v-select {
        min-height: 36px;
    }

    .v-select .vs__selected-options {
        align-items: center;
        margin-bottom: 5px;

        .vs__selected {
            margin: 5px 0 0 5px;
        }
    }
}
</style>
